import script from "./WagersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WagersView.vue?vue&type=script&setup=true&lang=ts"

import "./WagersView.vue?vue&type=style&index=0&id=8f120694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f120694"]])

export default __exports__